/****************************************************
 * Module Name:  keytosymbolProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class KeytosymbolProxy {
  static GetAllKeytosymbol = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/keytosymbol",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleKeytosymbol = (keytosymbolId, callback) => {
    let params = {
      id: keytosymbolId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/keytosymbol",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckKeytosymbolAvailable = (keytosymbol, callback) => {
    let params = {
      keytosymbol: keytosymbol,
    };

    restAPICall(
      Constants.MANAGER_URL + "/keytosymbol/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddKeytosymbol = (keytosymbol, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/keytosymbol",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(keytosymbol),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateKeytosymbol = (keytosymbol, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/keytosymbol",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(keytosymbol),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteKeytosymbol = (keytosymbol, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/keytosymbol",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(keytosymbol),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
